<template>
  <div class="TabCmp">
    <div class="tab-guards light-grey-bg">
      <div :class="guardsClasses">
        <ul>
          <li 
            :class="['tab-guard', { 'active' : activeTab.slug === tab.slug }]" 
            v-for="tab in tabs">
            <a 
              href="#" 
              :data-slug="tab.slug" 
              @click="onRouterLinkClick">
              <span v-html="tab.text"></span>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="tab-panels">
      <div :class="panelClasses">
        <slot name="content"></slot>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
  export default {
    name: "TabsCmp",
    data: ()=>{
      return {
        activeTab: {
          slug: null
        }
      }
    },
    methods: {
      onRouterLinkClick: function(e){
        e.preventDefault();
        let tab = this.tabs.find((a)=> a.slug === e.currentTarget.dataset.slug)
        if(tab){
          if(tab.external){
            let a= document.createElement('a');
            a.target= '_blank';
            a.href= tab.href;
            a.click();
          }else this.activeTab = tab
        }
      }
    },
    props: {
      defaultTab: {
        type: String,
        default: ''
      },
      guardsClasses: { 
        type: Array, 
        default: () => { return [] }
      },
      panelClasses: { 
        type: Array, 
        default: () => { return [] }
      },
      tabs: { 
        type: Array, 
        default: () => { return [] }
      }
    },
    mounted: function(){
      this.activeTab = { slug: this.defaultTab }
      console.log(this.defaultTab, this.activeTab)
    },
    watch: {
      activeTab: function(){
        if(this.$router.currentRoute.name !== this.activeTab.slug){
          this.$router.push({ name: this.activeTab.slug })
        }
      }
    }
  };
</script>
<style lang="less" scoped>
  @import "~@root/less/func/variables";
  @import "~@root/less/func/elements";

  .TabCmp{
    .tab-panels{
      padding-top: 50px;
    }
    .tab-guards{
      border-top: 1px solid @gray5;
      border-bottom: 1px solid @gray5;
      ul{
        margin: 0 -20px;
        list-style: none;
        display: flex;
        overflow: auto;

        @media (min-width: @bootstrap-md){
          margin: 0 -15px;
          overflow: hidden;
        }

        li{
          list-style: none;
          line-height: 80px;
          font-size: 14px;
          display: inline-block;
          padding: 0 20px;

          > a{
            color: @gray2;
            .Typo-Size(14px, 80px);
            display: block;
            white-space: nowrap;
            font-weight: @Semibold;
            position: relative;
            .transition(.3s, color);
            padding-bottom: 1px;
            line-height: 50px;
            font-weight: @Regular;

            @media (min-width: @bootstrap-md){
              line-height: 81px;
              font-weight: @Semibold;
            }

            &:after
            {
                content: ' ';
                display: block;
                width: 100%;
                height: 0;
                position: absolute;
                left: 0;
                bottom: 0;
                background: @green;
                .transition(.3s, height);
            }

            &:hover
            {
                color: @black;
            }
          }

          &.active{
            > a
            {
              color: @black;
              &:after{
                height: 3px;
              }
            }
          }

          @media (min-width: @bootstrap-md){
            padding: 0 15px;
          }
        }
      }
    }
  }
</style>
